export default "__VITE_ASSET__DljIFa6x__"